import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // we init with resources
        resources: {
            en: {
                translations:{
                        "Home": "Home",
                        "Car Minimal Demo": "Car Minimal Demo",
                        "Job Minimal Demo": "Job Minimal Demo",
                        "Property Minimal Demo": "Property Minimal Demo",
                        "Coming Soon": "Coming Soon",
                        "Property": "Property",
                        "Grid Pages": "Grid Pages",
                        "property 2 grid": "Property 2 Grid",
                        "property 2 right grid": "Property 2 Right Grid",
                        "property 3 grid": "Property 3 Grid",
                        "property 3 right grid": "Property 3 Right Grid",
                        "property 4 grid": "Property 4 Grid",
                        "property no sidebar": "Property No Sidebar",
                        "Listing Pages": "Listing Pages",
                        "property left list": "Property Left List",
                        "property right list": "Property Right List",
                        "property video list": "Property Video List",
                        "property thumb list": "Property Thumb List",
                        "property without slider": "Property Without Slider",
                        "Other Pages": "Other Pages",
                        "property left drawer": "Property Left Drawer",
                        "property right drawer": "Property Right Drawer",
                        "property infinite scroll": "Property Infinite Scroll",
                        "property load more": "Property Load More",
                        "property parallax": "Property Parallax",
                        "property grid without slider": "Property Grid Without Slider",
                        "Map Pages": "Map Pages",
                        "property left map": "Property Left Map",
                        "property right map": "Property Right Map",
                        "property list map": "Property List Map",
                        "property modal map": "Property Modal Map",
                        "Detail Pages": "Detail Pages",
                        "property classic": "Property Classic",
                        "property scrollspy": "Property Scrollspy",
                        "property tab": "Property Tab",
                        "property accordion": "Property Accordion",
                        "property image slider": "Property Image Slider",
                        "property sticky": "Property Sticky",
                        "property sidebar layout": "Property Sidebar Layout",
                        "property video": "Property Video",
                        "property thumb slider": "Property Thumb Slider",
                        "property animated icon": "Property Animated Icon",
                        "property wishlist": "Property Wishlist",
                        "Car": "Car",
                        "Car 2 grid": "Car 2 Grid",
                        "Car 2 right grid": "Car 2 Right Grid",
                        "Car 3 grid": "Car 3 Grid",
                        "Car 3 right grid": "Car 3 Right Grid",
                        "Car no sidebar": "Car No Sidebar",
                        "Car left list": "Car Left List",
                        "Car right list": "Car Right List",
                        "Car left drawer": "Car Left Drawer",
                        "Car right drawer": "Car Right Drawer",
                        "Car infinite scroll": "Car Infinite Scroll",
                        "Car load more": "Car Load More",
                        "car top category": "Car Top Category",
                        "car top filter": "Car Top Filter",
                        "car without slider": "Car Without Slider",
                        "car classic": "Car Classic",
                        "car layout 1": "Car Layout 1",
                        "car layout 2": "Car Layout 2",
                        "car slider": "Car Slider",
                        "car expand slider": "Car Expand Slider",
                        "car modern slider": "Car Modern Slider",
                        "car scrollspy": "Car Scrollspy",
                        "car video": "Car Video",
                        "car classic slider": "Car Classic Slider",
                        "car thumbnail slider": "Car Thumbnail Slider",
                        "car wishlist": "Car Wishlist",
                        "Job": "Job",
                        "job grid progress": "Job Grid Progress",
                        "job grid type-2": "Job Grid Type 2",
                        "job grid type 3": "Job Grid Type 3",
                        "job 2 grid": "Job 2 Grid",
                        "job 2 right grid": "Job 2 Right Grid",
                        "Job no sidebar": "Job No Sidebar",
                        "Job left list": "Job Left List",
                        "Job right list": "Job Right List",
                        "Job list no sidebar": "Job List No Sidebar",
                        "Job left drawer": "Job Left Drawer",
                        "Job right drawer": "Job Right Drawer",
                        "Job infinite scroll": "Job Infinite Scroll",
                        "Job load more": "Job Load More",
                        "Job ad": "Job Ad",
                        "Job filter": "Job Filter",
                        "job full list": "Job Full List",
                        "job both sidebar": "Job Both Sidebar",
                        "job list style 2": "Job List Style 2",
                        "job detail 1": "Job Detail 1",
                        "job detail 2": "Job Detail 2",
                        "job detail 3": "Job Detail 3",
                        "job detail 4": "Job Detail 4",
                        "job detail 5": "Job Detail 5",
                        "job wishlist": "Job Wishlist",
                        "Pages": "Pages",
                        "Blog Pages": "Blog Pages",
                        "blog left sidebar": "Blog Left Sidebar",
                        "blog right sidebar": "Blog Right Sidebar",
                        "blog 2 grid": "Blog 2 Grid",
                        "blog 2 grid right": "Blog 2 Grid Right",
                        "blog title": "Blog Title",
                        "blog layout 1": "Blog Layout 1",
                        "blog no sidebar": "Blog No Sidebar",
                        "blog top slider": "Blog Top Slider",
                        "blog 3 masonry": "Blog 3 Masonry",
                        "blog load more": "Blog Load More",
                        "blog left list": "Blog Left List",
                        "blog right list": "Blog Right List",
                        "blog infinite scroll": "Blog Infinite Scroll",
                        "Blog Detail Pages": "Blog Detail Pages",
                        "blog left classic": "Blog Left Classic",
                        "blog right classic": "Blog Right Classic",
                        "blog video layout": "Blog Video Layout",
                        "blog audio layout": "Blog Audio Layout",
                        "blog slider layout": "Blog Slider Layout",
                        "blog quote layout": "Blog Quote Layout",
                        "Portfolio Pages": "Portfolio Pages",
                        "Portfolio 2 grid": "Portfolio 2 Grid",
                        "Portfolio 3 grid": "Portfolio 3 Grid",
                        "Portfolio 4 grid": "Portfolio 4 Grid",
                        "Portfolio transform": "Portfolio Transform",
                        "Portfolio video modal": "Portfolio Video Modal",
                        "Portfolio gallery icon": "Portfolio Gallery Icon",
                        "Portfolio image change": "Portfolio Image Change",
                        "Portfolio box slider": "Portfolio Box Slider",
                        "Portfolio parallax": "Portfolio Parallax",
                        "Portfolio vertical slider": "Portfolio Vertical Slider",
                        "Portfolio creative full": "Portfolio Creative Full",
                        "Portfolio modern": "Portfolio Modern",
                        "Portfolio Detail Pages": "Portfolio Detail Pages",
                        "Portfolio detail 1": "Portfolio Detail 1",
                        "Portfolio detail 2": "Portfolio Detail 2",
                        "About Us 1": "About Us 1",
                        "About Us 2": "About Us 2",
                        "About Us 3": "About Us 3",
                        "contact Us 1": "Contact Us 1",
                        "contact Us 2": "Contact Us 2",
                        "contact Us 3": "Contact Us 3",
                        "Services": "Services",
                        "Our Team": "Our Team",
                        "Pricing": "Pricing",
                        "Testimonial": "Testimonial",
                        "FAQ": "FAQ",
                        "User Dashboard": "User Dashboard",
                        "privacy": "Privacy",
                        "Terms & Condition": "Terms & Condition",
                        "404": "404",
                        "Login 1": "Login 1",
                        "Login 2": "Login 2",
                        "Login 3": "Login 3",
                        "Login 4": "Login 4",
                        "Signup 1": "Signup 1",
                        "Signup 2": "Signup 2",
                        "Signup 3": "Signup 3"
                      
                },               
            },
            sp:{
                translations:{
                        "Home": "Inicio",
                        "Car Minimal Demo": "Demostración Mínima de Carro",
                        "Job Minimal Demo": "Demostración Mínima de Trabajo",
                        "Property Minimal Demo": "Demostración Mínima de Propiedad",
                        "Coming Soon": "Próximamente",
                        "Property": "Propiedad",
                        "Grid Pages": "Páginas de Cuadrícula",
                        "property 2 grid": "Propiedad 2 Cuadrícula",
                        "property 2 right grid": "Propiedad 2 Cuadrícula Derecha",
                        "property 3 grid": "Propiedad 3 Cuadrícula",
                        "property 3 right grid": "Propiedad 3 Cuadrícula Derecha",
                        "property 4 grid": "Propiedad 4 Cuadrícula",
                        "property no sidebar": "Propiedad Sin Barra Lateral",
                        "Listing Pages": "Páginas de Listado",
                        "property left list": "Propiedad Lista Izquierda",
                        "property right list": "Propiedad Lista Derecha",
                        "property video list": "Propiedad Lista de Video",
                        "property thumb list": "Propiedad Lista de Miniaturas",
                        "property without slider": "Propiedad Sin Deslizador",
                        "Other Pages": "Otras Páginas",
                        "property left drawer": "Propiedad Cajón Izquierdo",
                        "property right drawer": "Propiedad Cajón Derecho",
                        "property infinite scroll": "Propiedad Desplazamiento Infinito",
                        "property load more": "Propiedad Cargar Más",
                        "property parallax": "Propiedad Parallax",
                        "property grid without slider": "Propiedad Cuadrícula Sin Deslizador",
                        "Map Pages": "Páginas de Mapa",
                        "property left map": "Propiedad Mapa Izquierdo",
                        "property right map": "Propiedad Mapa Derecho",
                        "property list map": "Propiedad Lista Mapa",
                        "property modal map": "Propiedad Mapa Modal",
                        "Detail Pages": "Páginas de Detalle",
                        "property classic": "Propiedad Clásica",
                        "property scrollspy": "Propiedad Scrollspy",
                        "property tab": "Propiedad Pestaña",
                        "property accordion": "Propiedad Acordeón",
                        "property image slider": "Propiedad Deslizador de Imágenes",
                        "property sticky": "Propiedad Fija",
                        "property sidebar layout": "Propiedad Diseño de Barra Lateral",
                        "property video": "Propiedad Video",
                        "property thumb slider": "Propiedad Deslizador de Miniaturas",
                        "property animated icon": "Propiedad Icono Animado",
                        "property wishlist": "Propiedad Lista de Deseos",
                        "Car": "Carro",
                        "Car 2 grid": "Carro 2 Cuadrícula",
                        "Car 2 right grid": "Carro 2 Cuadrícula Derecha",
                        "Car 3 grid": "Carro 3 Cuadrícula",
                        "Car 3 right grid": "Carro 3 Cuadrícula Derecha",
                        "Car no sidebar": "Carro Sin Barra Lateral",
                        "Car left list": "Carro Lista Izquierda",
                        "Car right list": "Carro Lista Derecha",
                        "Car left drawer": "Carro Cajón Izquierdo",
                        "Car right drawer": "Carro Cajón Derecho",
                        "Car infinite scroll": "Carro Desplazamiento Infinito",
                        "Car load more": "Carro Cargar Más",
                        "car top category": "Carro Categoría Superior",
                        "car top filter": "Carro Filtro Superior",
                        "car without slider": "Carro Sin Deslizador",
                        "car classic": "Carro Clásico",
                        "car layout 1": "Carro Diseño 1",
                        "car layout 2": "Carro Diseño 2",
                        "car slider": "Carro Deslizador",
                        "car expand slider": "Carro Deslizador Expandido",
                        "car modern slider": "Carro Deslizador Moderno",
                        "car scrollspy": "Carro Scrollspy",
                        "car video": "Carro Video",
                        "car classic slider": "Carro Deslizador Clásico",
                        "car thumbnail slider": "Carro Deslizador de Miniaturas",
                        "car wishlist": "Carro Lista de Deseos",
                        "Job": "Trabajo",
                        "job grid progress": "Trabajo Progreso de Cuadrícula",
                        "job grid type-2": "Trabajo Cuadrícula Tipo 2",
                        "job grid type 3": "Trabajo Cuadrícula Tipo 3",
                        "job 2 grid": "Trabajo 2 Cuadrícula",
                        "job 2 right grid": "Trabajo 2 Cuadrícula Derecha",
                        "Job no sidebar": "Trabajo Sin Barra Lateral",
                        "Job left list": "Trabajo Lista Izquierda",
                        "Job right list": "Trabajo Lista Derecha",
                        "Job list no sidebar": "Trabajo Lista Sin Barra Lateral",
                        "Job left drawer": "Trabajo Cajón Izquierdo",
                        "Job right drawer": "Trabajo Cajón Derecho",
                        "Job infinite scroll": "Trabajo Desplazamiento Infinito",
                        "Job load more": "Trabajo Cargar Más",
                        "Job ad": "Anuncio de Trabajo",
                        "Job filter": "Filtro de Trabajo",
                        "job full list": "Trabajo Lista Completa",
                        "job both sidebar": "Trabajo Ambas Barras Laterales",
                        "job list style 2": "Trabajo Estilo de Lista 2",
                        "job detail 1": "Detalle de Trabajo 1",
                        "job detail 2": "Detalle de Trabajo 2",
                        "job detail 3": "Detalle de Trabajo 3",
                        "job detail 4": "Detalle de Trabajo 4",
                        "job detail 5": "Detalle de Trabajo 5",
                        "job wishlist": "Trabajo Lista de Deseos",
                        "Pages": "Páginas",
                        "Blog Pages": "Páginas de Blog",
                        "blog left sidebar": "Blog Barra Lateral Izquierda",
                        "blog right sidebar": "Blog Barra Lateral Derecha",
                        "blog 2 grid": "Blog 2 Cuadrícula",
                        "blog 2 grid right": "Blog 2 Cuadrícula Derecha",
                        "blog title": "Título de Blog",
                        "blog layout 1": "Blog Diseño 1",
                        "blog no sidebar": "Blog Sin Barra Lateral",
                        "blog top slider": "Blog Deslizador Superior",
                        "blog 3 masonry": "Blog 3 Masonería",
                        "blog load more": "Blog Cargar Más",
                        "blog left list": "Blog Lista Izquierda",
                        "blog right list": "Blog Lista Derecha",
                        "blog infinite scroll": "Blog Desplazamiento Infinito",
                        "Blog Detail Pages": "Páginas de Detalle del Blog",
                        "blog left classic": "Blog Clásico Izquierda",
                        "blog right classic": "Blog Clásico Derecha",
                        "blog video layout": "Blog Diseño de Video",
                        "blog audio layout": "Blog Diseño de Audio",
                        "blog slider layout": "Blog Diseño de Deslizador",
                        "blog quote layout": "Blog Diseño de Citas",
                        "Portfolio Pages": "Páginas de Portafolio",
                        "Portfolio 2 grid": "Portafolio 2 Cuadrícula",
                        "Portfolio 3 grid": "Portafolio 3 Cuadrícula",
                        "Portfolio 4 grid": "Portafolio 4 Cuadrícula",
                        "Portfolio transform": "Portafolio Transformado",
                        "Portfolio video modal": "Portafolio Video Modal",
                        "Portfolio gallery icon": "Portafolio Icono de Galería",
                        "Portfolio image change": "Portafolio Cambio de Imagen",
                        "Portfolio box slider": "Portafolio Deslizador de Caja",
                        "Portfolio parallax": "Portafolio Parallax",
                        "Portfolio vertical slider": "Portafolio Deslizador Vertical",
                        "Portfolio creative full": "Portafolio Creativo Completo",
                        "Portfolio modern": "Portafolio Moderno",
                        "Portfolio Detail Pages": "Páginas de detalles de la cartera",
                        "Portfolio detail 1": "Detalle de Portafolio 1",
                        "Portfolio detail 2": "Detalle de Portafolio 2",
                        "About Us 1": "Sobre Nosotros 1",
                        "About Us 2": "Sobre Nosotros 2",
                        "About Us 3": "Sobre Nosotros 3",
                        "contact Us 1": "Contáctenos 1",
                        "contact Us 2": "Contáctenos 2",
                        "contact Us 3": "Contáctenos 3",
                        "Services": "Servicios",
                        "Our Team": "Nuestro Equipo",
                        "Pricing": "Precios",
                        "Testimonial": "Testimonios",
                        "FAQ": "Preguntas Frecuentes",
                        "User Dashboard": "Panel de Usuario",
                        "privacy": "Privacidad",
                        "Terms & Condition": "Términos y Condiciones",
                        "404": "404",
                        "Login 1": "Iniciar Sesión 1",
                        "Login 2": "Iniciar Sesión 2",
                        "Login 3": "Iniciar Sesión 3",
                        "Login 4": "Iniciar Sesión 4",
                        "Signup 1": "Inscribirse 1",
                        "Signup 2": "Inscribirse 2",
                        "Signup 3": "Inscribirse 3"
                },
            },
            fr:{translations:{
                "Home": "Accueil",
                "Car Minimal Demo": "Démo Minimaliste de Voiture",
                "Job Minimal Demo": "Démo Minimaliste de Travail",
                "Property Minimal Demo": "Démo Minimaliste de Propriété",
                "Coming Soon": "Bientôt Disponible",
                "Property": "Propriété",
                "Grid Pages": "Pages de Grille",
                "property 2 grid": "Propriété 2 Grille",
                "property 2 right grid": "Propriété 2 Grille Droite",
                "property 3 grid": "Propriété 3 Grille",
                "property 3 right grid": "Propriété 3 Grille Droite",
                "property 4 grid": "Propriété 4 Grille",
                "property no sidebar": "Propriété Sans Barre Latérale",
                "Listing Pages": "Pages de Liste",
                "property left list": "Propriété Liste Gauche",
                "property right list": "Propriété Liste Droite",
                "property video list": "Propriété Liste Vidéo",
                "property thumb list": "Propriété Liste Miniatures",
                "property without slider": "Propriété Sans Curseur",
                "Other Pages": "Autres Pages",
                "property left drawer": "Propriété Tiroir Gauche",
                "property right drawer": "Propriété Tiroir Droit",
                "property infinite scroll": "Propriété Défilement Infini",
                "property load more": "Propriété Charger Plus",
                "property parallax": "Propriété Parallaxe",
                "property grid without slider": "Propriété Grille Sans Curseur",
                "Map Pages": "Pages de Carte",
                "property left map": "Propriété Carte Gauche",
                "property right map": "Propriété Carte Droite",
                "property list map": "Propriété Liste Carte",
                "property modal map": "Propriété Carte Modale",
                "Detail Pages": "Pages de Détail",
                "property classic": "Propriété Classique",
                "property scrollspy": "Propriété Scrollspy",
                "property tab": "Propriété Onglet",
                "property accordion": "Propriété Accordéon",
                "property image slider": "Propriété Curseur d'Images",
                "property sticky": "Propriété Collante",
                "property sidebar layout": "Propriété Mise en Page Barre Latérale",
                "property video": "Propriété Vidéo",
                "property thumb slider": "Propriété Curseur Miniatures",
                "property animated icon": "Propriété Icône Animée",
                "property wishlist": "Propriété Liste de Souhaits",
                "Car": "Voiture",
                "Car 2 grid": "Voiture 2 Grille",
                "Car 2 right grid": "Voiture 2 Grille Droite",
                "Car 3 grid": "Voiture 3 Grille",
                "Car 3 right grid": "Voiture 3 Grille Droite",
                "Car no sidebar": "Voiture Sans Barre Latérale",
                "Car left list": "Voiture Liste Gauche",
                "Car right list": "Voiture Liste Droite",
                "Car left drawer": "Voiture Tiroir Gauche",
                "Car right drawer": "Voiture Tiroir Droit",
                "Car infinite scroll": "Voiture Défilement Infini",
                "Car load more": "Voiture Charger Plus",
                "car top category": "Voiture Catégorie Supérieure",
                "car top filter": "Voiture Filtre Supérieur",
                "car without slider": "Voiture Sans Curseur",
                "car classic": "Voiture Classique",
                "car layout 1": "Voiture Mise en Page 1",
                "car layout 2": "Voiture Mise en Page 2",
                "car slider": "Voiture Curseur",
                "car expand slider": "Voiture Curseur Élargi",
                "car modern slider": "Voiture Curseur Moderne",
                "car scrollspy": "Voiture Scrollspy",
                "car video": "Voiture Vidéo",
                "car classic slider": "Voiture Curseur Classique",
                "car thumbnail slider": "Voiture Curseur Miniatures",
                "car wishlist": "Voiture Liste de Souhaits",
                "Job": "Emploi",
                "job grid progress": "Emploi Progression Grille",
                "job grid type-2": "Emploi Grille Type 2",
                "job grid type 3": "Emploi Grille Type 3",
                "job 2 grid": "Emploi 2 Grille",
                "job 2 right grid": "Emploi 2 Grille Droite",
                "Job no sidebar": "Emploi Sans Barre Latérale",
                "Job left list": "Emploi Liste Gauche",
                "Job right list": "Emploi Liste Droite",
                "Job list no sidebar": "Emploi Liste Sans Barre Latérale",
                "Job left drawer": "Emploi Tiroir Gauche",
                "Job right drawer": "Emploi Tiroir Droit",
                "Job infinite scroll": "Emploi Défilement Infini",
                "Job load more": "Emploi Charger Plus",
                "Job ad": "Annonce d'Emploi",
                "Job filter": "Filtre d'Emploi",
                "job full list": "Emploi Liste Complète",
                "job both sidebar": "Emploi Double Barre Latérale",
                "job list style 2": "Emploi Style de Liste 2",
                "job detail 1": "Détail d'Emploi 1",
                "job detail 2": "Détail d'Emploi 2",
                "job detail 3": "Détail d'Emploi 3",
                "job detail 4": "Détail d'Emploi 4",
                "job detail 5": "Détail d'Emploi 5",
                "job wishlist": "Emploi Liste de Souhaits",
                "Pages": "Pages",
                "Blog Pages": "Pages de Blog",
                "blog left sidebar": "Blog Barre Latérale Gauche",
                "blog right sidebar": "Blog Barre Latérale Droite",
                "blog 2 grid": "Blog 2 Grille",
                "blog 2 grid right": "Blog 2 Grille Droite",
                "blog title": "Titre du Blog",
                "blog layout 1": "Blog Mise en Page 1",
                "blog no sidebar": "Blog Sans Barre Latérale",
                "blog top slider": "Blog Curseur Supérieur",
                "blog 3 masonry": "Blog 3 Maçonnerie",
                "blog load more": "Blog Charger Plus",
                "blog left list": "Blog Liste Gauche",
                "blog right list": "Blog Liste Droite",
                "blog infinite scroll": "Blog Défilement Infini",
                "Blog Detail Pages": "Pages de Détail du Blog",
                "blog left classic": "Blog Classique Gauche",
                "blog right classic": "Blog Classique Droite",
                "blog video layout": "Blog Mise en Page Vidéo",
                "blog audio layout": "Blog Mise en Page Audio",
                "blog slider layout": "Blog Mise en Page Curseur",
                "blog quote layout": "Blog Mise en Page Citation",
                "Portfolio Pages": "Pages de Portfolio",
                "Portfolio 2 grid": "Portfolio 2 Grille",
                "Portfolio 3 grid": "Portfolio 3 Grille",
                "Portfolio 4 grid": "Portfolio 4 Grille",
                "Portfolio transform": "Portfolio Transformation",
                "Portfolio video modal": "Portfolio Vidéo Modal",
                "Portfolio gallery icon": "Portfolio Icône Galerie",
                "Portfolio image change": "Portfolio Changement d'Image",
                "Portfolio box slider": "Portfolio Curseur Boîte",
                "Portfolio parallax": "Portfolio Parallaxe",
                "Portfolio vertical slider": "Portfolio Curseur Vertical",
                "Portfolio creative full": "Portfolio Créatif Complet",
                "Portfolio modern": "Portfolio Moderne",
                "Portfolio Detail Pages": "Pages de détails du portefeuille",
                "Portfolio detail 1": "Détail de Portfolio 1",
                "Portfolio detail 2": "Détail de Portfolio 2",
                "About Us 1": "À Propos de Nous 1",
                "About Us 2": "À Propos de Nous 2",
                "About Us 3": "À Propos de Nous 3",
                "contact Us 1": "Contactez-Nous 1",
                "contact Us 2": "Contactez-Nous 2",
                "contact Us 3": "Contactez-Nous 3",
                "Services": "Services",
                "Our Team": "Notre Équipe",
                "Pricing": "Tarification",
                "Testimonial": "Témoignages",
                "FAQ": "FAQ",
                "User Dashboard": "Tableau de Bord Utilisateur",
                "privacy": "Confidentialité",
                "Terms & Condition": "Termes et Conditions",
                "404": "404",
                "Login 1": "Connexion 1",
                "Login 2": "Connexion 2",
                "Login 3": "Connexion 3",
                "Login 4": "Connexion 4",
                "Signup 1": "Inscription 1",
                "Signup 2": "Inscription 2",
                "Signup 3": "Inscription 3"
            }},
            ge:{translations:{
                "Home": "Startseite",
                "Car Minimal Demo": "Minimal-Demo für Autos",
                "Job Minimal Demo": "Minimal-Demo für Jobs",
                "Property Minimal Demo": "Minimal-Demo für Immobilien",
                "Coming Soon": "Demnächst",
                "Property": "Immobilien",
                "Grid Pages": "Rasterseiten",
                "property 2 grid": "Immobilien 2 Raster",
                "property 2 right grid": "Immobilien 2 Rechts-Raster",
                "property 3 grid": "Immobilien 3 Raster",
                "property 3 right grid": "Immobilien 3 Rechts-Raster",
                "property 4 grid": "Immobilien 4 Raster",
                "property no sidebar": "Immobilien ohne Seitenleiste",
                "Listing Pages": "Anzeigenseiten",
                "property left list": "Immobilien Linke Liste",
                "property right list": "Immobilien Rechte Liste",
                "property video list": "Immobilien Videoliste",
                "property thumb list": "Immobilien Miniaturliste",
                "property without slider": "Immobilien ohne Slider",
                "Other Pages": "Andere Seiten",
                "property left drawer": "Immobilien Linke Schublade",
                "property right drawer": "Immobilien Rechte Schublade",
                "property infinite scroll": "Immobilien Unendliches Scrollen",
                "property load more": "Immobilien Mehr Laden",
                "property parallax": "Immobilien Parallax",
                "property grid without slider": "Immobilien Raster ohne Slider",
                "Map Pages": "Kartenseiten",
                "property left map": "Immobilien Linke Karte",
                "property right map": "Immobilien Rechte Karte",
                "property list map": "Immobilien Listenkarte",
                "property modal map": "Immobilien Modalkarte",
                "Detail Pages": "Detailseiten",
                "property classic": "Immobilien Klassisch",
                "property scrollspy": "Immobilien Scrollspy",
                "property tab": "Immobilien Tab",
                "property accordion": "Immobilien Akkordeon",
                "property image slider": "Immobilien Bildslider",
                "property sticky": "Immobilien Sticky",
                "property sidebar layout": "Immobilien Seitenleisten-Layout",
                "property video": "Immobilien Video",
                "property thumb slider": "Immobilien Miniatur-Slider",
                "property animated icon": "Immobilien Animiertes Symbol",
                "property wishlist": "Immobilien Wunschliste",
                "Car": "Auto",
                "Car 2 grid": "Auto 2 Raster",
                "Car 2 right grid": "Auto 2 Rechts-Raster",
                "Car 3 grid": "Auto 3 Raster",
                "Car 3 right grid": "Auto 3 Rechts-Raster",
                "Car no sidebar": "Auto ohne Seitenleiste",
                "Car left list": "Auto Linke Liste",
                "Car right list": "Auto Rechte Liste",
                "Car left drawer": "Auto Linke Schublade",
                "Car right drawer": "Auto Rechte Schublade",
                "Car infinite scroll": "Auto Unendliches Scrollen",
                "Car load more": "Auto Mehr Laden",
                "car top category": "Auto Oberkategorie",
                "car top filter": "Auto Oberer Filter",
                "car without slider": "Auto ohne Slider",
                "car classic": "Auto Klassisch",
                "car layout 1": "Auto Layout 1",
                "car layout 2": "Auto Layout 2",
                "car slider": "Auto Slider",
                "car expand slider": "Auto Erweiterter Slider",
                "car modern slider": "Auto Moderner Slider",
                "car scrollspy": "Auto Scrollspy",
                "car video": "Auto Video",
                "car classic slider": "Auto Klassischer Slider",
                "car thumbnail slider": "Auto Miniatur-Slider",
                "car wishlist": "Auto Wunschliste",
                "Job": "Job",
                "job grid progress": "Job Raster Fortschritt",
                "job grid type-2": "Job Raster Typ 2",
                "job grid type 3": "Job Raster Typ 3",
                "job 2 grid": "Job 2 Raster",
                "job 2 right grid": "Job 2 Rechts-Raster",
                "Job no sidebar": "Job ohne Seitenleiste",
                "Job left list": "Job Linke Liste",
                "Job right list": "Job Rechte Liste",
                "Job list no sidebar": "Job Liste ohne Seitenleiste",
                "Job left drawer": "Job Linke Schublade",
                "Job right drawer": "Job Rechte Schublade",
                "Job infinite scroll": "Job Unendliches Scrollen",
                "Job load more": "Job Mehr Laden",
                "Job ad": "Job Anzeige",
                "Job filter": "Job Filter",
                "job full list": "Job Gesamtliste",
                "job both sidebar": "Job Beide Seitenleisten",
                "job list style 2": "Job Listenstil 2",
                "job detail 1": "Job Detail 1",
                "job detail 2": "Job Detail 2",
                "job detail 3": "Job Detail 3",
                "job detail 4": "Job Detail 4",
                "job detail 5": "Job Detail 5",
                "job wishlist": "Job Wunschliste",
                "Pages": "Seiten",
                "Blog Pages": "Blog-Seiten",
                "blog left sidebar": "Blog Linke Seitenleiste",
                "blog right sidebar": "Blog Rechte Seitenleiste",
                "blog 2 grid": "Blog 2 Raster",
                "blog 2 grid right": "Blog 2 Rechts-Raster",
                "blog title": "Blog Titel",
                "blog layout 1": "Blog Layout 1",
                "blog no sidebar": "Blog ohne Seitenleiste",
                "blog top slider": "Blog Oberer Slider",
                "blog 3 masonry": "Blog 3 Mauerwerk",
                "blog load more": "Blog Mehr Laden",
                "blog left list": "Blog Linke Liste",
                "blog right list": "Blog Rechte Liste",
                "blog infinite scroll": "Blog Unendliches Scrollen",
                "Blog Detail Pages": "Blog-Detailseiten",
                "blog left classic": "Blog Klassisch Links",
                "blog right classic": "Blog Klassisch Rechts",
                "blog video layout": "Blog Video-Layout",
                "blog audio layout": "Blog Audio-Layout",
                "blog slider layout": "Blog Slider-Layout",
                "blog quote layout": "Blog Zitat-Layout",
                "Portfolio Pages": "Portfolio-Seiten",
                "Portfolio 2 grid": "Portfolio 2 Raster",
                "Portfolio 3 grid": "Portfolio 3 Raster",
                "Portfolio 4 grid": "Portfolio 4 Raster",
                "Portfolio transform": "Portfolio Transformation",
                "Portfolio video modal": "Portfolio Video-Modale",
                "Portfolio gallery icon": "Portfolio Galerie-Symbol",
                "Portfolio image change": "Portfolio Bildwechsel",
                "Portfolio box slider": "Portfolio Box-Slider",
                "Portfolio parallax": "Portfolio Parallax",
                "Portfolio vertical slider": "Portfolio Vertikaler Slider",
                "Portfolio creative full": "Portfolio Kreativ Vollbild",
                "Portfolio modern": "Portfolio Modern",
                "Portfolio Detail Pages": "Portfolio Detailseiten",
                "Portfolio detail 1": "Portfolio Detail 1",
                "Portfolio detail 2": "Portfolio Detail 2",
                "About Us 1": "Über Uns 1",
                "About Us 2": "Über Uns 2",
                "About Us 3": "Über Uns 3",
                "contact Us 1": "Kontaktieren Sie uns 1",
                "contact Us 2": "Kontaktieren Sie uns 2",
                "contact Us 3": "Kontaktieren Sie uns 3",
                "Services": "Dienstleistungen",
                "Our Team": "Unser Team",
                "Pricing": "Preise",
                "Testimonial": "Testimonials",
                "FAQ": "FAQ",
                "User Dashboard": "Benutzer-Dashboard",
                "privacy": "Datenschutz",
                "Terms & Condition": "AGB",
                "404": "404",
                "Login 1": "Anmeldung 1",
                "Login 2": "Anmeldung 2",
                "Login 3": "Anmeldung 3",
                "Login 4": "Anmeldung 4",
                "Signup 1": "Registrierung 1",
                "Signup 2": "Registrierung 2",
                "Signup 3": "Registrierung 3"
            }},
            ko:{translations:{
                "Home": "홈",
                "Car Minimal Demo": "자동차 미니멀 데모",
                "Job Minimal Demo": "직업 미니멀 데모",
                "Property Minimal Demo": "부동산 미니멀 데모",
                "Coming Soon": "곧 출시 예정",
                "Property": "부동산",
                "Grid Pages": "그리드 페이지",
                "property 2 grid": "부동산 2 그리드",
                "property 2 right grid": "부동산 2 오른쪽 그리드",
                "property 3 grid": "부동산 3 그리드",
                "property 3 right grid": "부동산 3 오른쪽 그리드",
                "property 4 grid": "부동산 4 그리드",
                "property no sidebar": "부동산 사이드바 없음",
                "Listing Pages": "리스트 페이지",
                "property left list": "부동산 왼쪽 리스트",
                "property right list": "부동산 오른쪽 리스트",
                "property video list": "부동산 비디오 리스트",
                "property thumb list": "부동산 썸네일 리스트",
                "property without slider": "슬라이더 없는 부동산",
                "Other Pages": "기타 페이지",
                "property left drawer": "부동산 왼쪽 드로어",
                "property right drawer": "부동산 오른쪽 드로어",
                "property infinite scroll": "부동산 무한 스크롤",
                "property load more": "부동산 더 불러오기",
                "property parallax": "부동산 패럴럭스",
                "property grid without slider": "슬라이더 없는 부동산 그리드",
                "Map Pages": "지도 페이지",
                "property left map": "부동산 왼쪽 지도",
                "property right map": "부동산 오른쪽 지도",
                "property list map": "부동산 리스트 지도",
                "property modal map": "부동산 모달 지도",
                "Detail Pages": "상세 페이지",
                "property classic": "부동산 클래식",
                "property scrollspy": "부동산 스크롤스파이",
                "property tab": "부동산 탭",
                "property accordion": "부동산 아코디언",
                "property image slider": "부동산 이미지 슬라이더",
                "property sticky": "부동산 스티키",
                "property sidebar layout": "부동산 사이드바 레이아웃",
                "property video": "부동산 비디오",
                "property thumb slider": "부동산 썸네일 슬라이더",
                "property animated icon": "부동산 애니메이션 아이콘",
                "property wishlist": "부동산 위시리스트",
                "Car": "자동차",
                "Car 2 grid": "자동차 2 그리드",
                "Car 2 right grid": "자동차 2 오른쪽 그리드",
                "Car 3 grid": "자동차 3 그리드",
                "Car 3 right grid": "자동차 3 오른쪽 그리드",
                "Car no sidebar": "자동차 사이드바 없음",
                "Car left list": "자동차 왼쪽 리스트",
                "Car right list": "자동차 오른쪽 리스트",
                "Car left drawer": "자동차 왼쪽 드로어",
                "Car right drawer": "자동차 오른쪽 드로어",
                "Car infinite scroll": "자동차 무한 스크롤",
                "Car load more": "자동차 더 불러오기",
                "car top category": "자동차 상위 카테고리",
                "car top filter": "자동차 상위 필터",
                "car without slider": "슬라이더 없는 자동차",
                "car classic": "자동차 클래식",
                "car layout 1": "자동차 레이아웃 1",
                "car layout 2": "자동차 레이아웃 2",
                "car slider": "자동차 슬라이더",
                "car expand slider": "자동차 확장 슬라이더",
                "car modern slider": "자동차 현대 슬라이더",
                "car scrollspy": "자동차 스크롤스파이",
                "car video": "자동차 비디오",
                "car classic slider": "자동차 클래식 슬라이더",
                "car thumbnail slider": "자동차 썸네일 슬라이더",
                "car wishlist": "자동차 위시리스트",
                "Job": "직업",
                "job grid progress": "직업 그리드 진행",
                "job grid type-2": "직업 그리드 타입 2",
                "job grid type 3": "직업 그리드 타입 3",
                "job 2 grid": "직업 2 그리드",
                "job 2 right grid": "직업 2 오른쪽 그리드",
                "Job no sidebar": "직업 사이드바 없음",
                "Job left list": "직업 왼쪽 리스트",
                "Job right list": "직업 오른쪽 리스트",
                "Job list no sidebar": "직업 리스트 사이드바 없음",
                "Job left drawer": "직업 왼쪽 드로어",
                "Job right drawer": "직업 오른쪽 드로어",
                "Job infinite scroll": "직업 무한 스크롤",
                "Job load more": "직업 더 불러오기",
                "Job ad": "직업 광고",
                "Job filter": "직업 필터",
                "job full list": "직업 전체 리스트",
                "job both sidebar": "직업 양쪽 사이드바",
                "job list style 2": "직업 리스트 스타일 2",
                "job detail 1": "직업 상세 1",
                "job detail 2": "직업 상세 2",
                "job detail 3": "직업 상세 3",
                "job detail 4": "직업 상세 4",
                "job detail 5": "직업 상세 5",
                "job wishlist": "직업 위시리스트",
                "Pages": "페이지",
                "Blog Pages": "블로그 페이지",
                "blog left sidebar": "블로그 왼쪽 사이드바",
                "blog right sidebar": "블로그 오른쪽 사이드바",
                "blog 2 grid": "블로그 2 그리드",
                "blog 2 grid right": "블로그 2 그리드 오른쪽",
                "blog title": "블로그 제목",
                "blog layout 1": "블로그 레이아웃 1",
                "blog no sidebar": "블로그 사이드바 없음",
                "blog top slider": "블로그 상단 슬라이더",
                "blog 3 masonry": "블로그 3 매손리",
                "blog load more": "블로그 더 불러오기",
                "blog left list": "블로그 왼쪽 리스트",
                "blog right list": "블로그 오른쪽 리스트",
                "blog infinite scroll": "블로그 무한 스크롤",
                "Blog Detail Pages": "블로그 상세 페이지",
                "blog left classic": "블로그 왼쪽 클래식",
                "blog right classic": "블로그 오른쪽 클래식",
                "blog video layout": "블로그 비디오 레이아웃",
                "blog audio layout": "블로그 오디오 레이아웃",
                "blog slider layout": "블로그 슬라이더 레이아웃",
                "blog quote layout": "블로그 인용 레이아웃",
                "Portfolio Pages": "포트폴리오 페이지",
                "Portfolio 2 grid": "포트폴리오 2 그리드",
                "Portfolio 3 grid": "포트폴리오 3 그리드",
                "Portfolio 4 grid": "포트폴리오 4 그리드",
                "Portfolio transform": "포트폴리오 변환",
                "Portfolio video modal": "포트폴리오 비디오 모달",
                "Portfolio gallery icon": "포트폴리오 갤러리 아이콘",
                "Portfolio image change": "포트폴리오 이미지 변경",
                "Portfolio box slider": "포트폴리오 박스 슬라이더",
                "Portfolio parallax": "포트폴리오 패럴럭스",
                "Portfolio vertical slider": "포트폴리오 수직 슬라이더",
                "Portfolio creative full": "포트폴리오 창의적인 전체",
                "Portfolio modern": "포트폴리오 현대적",
                "Portfolio Detail Pages": "포트폴리오 세부 페이지",
                "Portfolio detail 1": "포트폴리오 상세 1",
                "Portfolio detail 2": "포트폴리오 상세 2",
                "About Us 1": "회사 소개 1",
                "About Us 2": "회사 소개 2",
                "About Us 3": "회사 소개 3",
                "contact Us 1": "문의하기 1",
                "contact Us 2": "문의하기 2",
                "contact Us 3": "문의하기 3",
                "Services": "서비스",
                "Our Team": "우리 팀",
                "Pricing": "가격",
                "Testimonial": "고객 후기",
                "FAQ": "자주 묻는 질문",
                "User Dashboard": "사용자 대시보드",
                "privacy": "개인정보 보호",
                "Terms & Condition": "이용 약관",
                "404": "404",
                "Login 1": "로그인 1",
                "Login 2": "로그인 2",
                "Login 3": "로그인 3",
                "Login 4": "로그인 4",
                "Signup 1": "가입 1",
                "Signup 2": "가입 2",
                "Signup 3": "가입 3"
              }}
        },
        fallbackLng: "en",
        debug: false,
        ns: ["translations"],
        defaultNS: "translations",
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;